
import { getInboundTransmissionByIdRequest, reimportTransmissionRequest } from  '../requests';

async function inspectInboundTransmission({ commit }, transmissionId) {
	let transmissionDetails = await getInboundTransmissionByIdRequest(transmissionId);
	commit('setTransmissionDetails', transmissionDetails);
}


async function reimportTransmission({ commit }, { transmissionId, callback }) {
	console.log(transmissionId, callback);
	let transmissionDetails = await reimportTransmissionRequest(transmissionId);
	commit('setTransmissionDetails', transmissionDetails);
	callback();
}
export default { inspectInboundTransmission, reimportTransmission };